// removed by extract-text-webpack-plugin
module.exports = {"formContainer":"requestUsername__formContainer--3N6Mp","headingContainer":"requestUsername__headingContainer--1hLmO","heading":"requestUsername__heading--N4O4m","link":"requestUsername__link--33w2m"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/UsernameRequest/requestUsername.css
// module id = TLLa
// module chunks = 36